import React, { type FC } from 'react'

/**
 *
 * Not the only use for this but one reason is:
 *
 * Use this to wrap around antd select drop down type components if you have a problem with it randomly
 * closing the dropdown when it shouldn't.
 *
 * Example:
 *
 * function dropdownRender(menu: React.ReactElement<any, string | React.JSXElementConstructor<any>>) {
 *     return <PreventClickPropagation>{menu}</PreventClickPropagation>
 * }
 */
export const PreventClickPropagation: FC = ({ children }) => {
    return (
        <div
            onMouseDown={(e) => {
                e.stopPropagation()
                e.preventDefault()
            }}
        >
            {children}
        </div>
    )
}
